module.exports = __webpack_public_path__ + "img/Operating System.123dc865.svg";